import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Icon } from '@iconify/react';

const ChatSidebar = ({
  conversations,
  streamingEnabled,
  setStreamingEnabled,
  isStreaming,
  aiProvider,
  setAiProvider,
  onNewChat,
  onLoadConversation,
  onUpdateConversationTitle,
  onDeleteConversation
}) => {
  return (
    <div className="w-300px h-100 offcanvas offcanvas-start bg-none position-lg-relative transform-lg-none visibility-lg-initial z-lg-3" id="aiChatSidebar">
      <div className="d-lg-none bg-blur-3 d-block position-absolute top-0 end-0 w-100 h-100"></div>
      
      <div className="position-relative h-100 d-flex flex-column">
        <div className="p-3">
          <button 
            type="button" 
            className="btn btn-outline-theme w-100 rounded-3 py-2 d-flex align-items-center justify-content-center" 
            onClick={onNewChat}
          >
            New Chat
          </button>
        </div>
        
        <hr className="m-0 opacity-20" />
        
        <div className="p-3">
        <div className="pb-3 btn-group w-100" role="group">
            <input 
              type="radio" 
              className="btn-check" 
              name="aiProvider" 
              id="openai" 
              checked={aiProvider === 'openai'} 
              onChange={() => setAiProvider('openai')}
            />
            <label className="btn btn-outline-theme btn-sm" htmlFor="openai">
              <i className="fab fa-openai me-1"></i>
              OpenAI
            </label>
            
            <input 
              type="radio" 
              className="btn-check" 
              name="aiProvider" 
              id="ollama" 
              checked={aiProvider === 'ollama'} 
              onChange={() => setAiProvider('ollama')}
            />
            <label className="btn btn-outline-theme btn-sm" htmlFor="ollama">
              <i className="fas fa-robot me-1"></i>
              OLLAMA
            </label>
          </div>
          <div className="form-check form-switch">
            <input 
              className="form-check-input" 
              type="checkbox" 
              id="streamingToggle" 
              checked={streamingEnabled}
              onChange={(e) => setStreamingEnabled(e.target.checked)}
              disabled={isStreaming}
            />
            <label className="form-check-label fs-13px" htmlFor="streamingToggle">
              {streamingEnabled ? (
                <>
                  <i className="fas fa-stream me-1"></i>
                  Streaming {isStreaming && <span className="text-success">(Active)</span>}
                </>
              ) : (
                <>
                  <i className="fas fa-pause me-1"></i>
                  Standard
                </>
              )}
            </label>
          </div>
          <div className="fs-11px text-body text-opacity-50 mt-1">
            {streamingEnabled ? 'Real-time response streaming' : 'Wait for complete response'}
          </div>
        </div>
        
        <hr className="m-0 opacity-20" />
        
        <div className="flex-1 overflow-hidden text-body">
          <PerfectScrollbar className="p-3 h-100">
            {conversations.length > 0 ? (
              <>
                <div className="fw-500 mb-1 d-flex align-items-center">
                  <Icon icon="solar:calendar-bold-duotone" className="fs-16px me-8px mt-n1 text-theme"></Icon> 
                  Your Conversations
                </div>
                <div className="px-2">
                  {conversations.map((conversation) => (
                    <div key={conversation.id} className="position-relative hover-bg-light bg-opacity-25 hover-show rounded-2 py-6px px-3 border-0 d-flex align-items-center">
                      <div className="flex-1 text-body text-opacity-75">{conversation.title}</div>
                      <a 
                        href="#/" 
                        className="stretched-link text-decoration-none" 
                        data-toggle-ai-tab="aiChatPrev" 
                        onClick={(e) => {
                          e.preventDefault();
                          onLoadConversation(conversation.id);
                        }}
                      >
                        &nbsp;
                      </a>
                      <div className="dropdown position-relative z-3">
                        <a href="#/" data-bs-toggle="dropdown" className="link-secondary opacity-50 d-none hover-show-elm">
                          <i className="fa fa-ellipsis"></i>
                        </a>
                        <div className="dropdown-menu">
                          <a 
                            href="#/" 
                            className="dropdown-item" 
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              const newTitle = prompt('Enter new title:', conversation.title);
                              if (newTitle && newTitle.trim() !== '') {
                                onUpdateConversationTitle(conversation.id, newTitle.trim());
                              }
                            }}
                          >
                            Rename
                          </a>
                          <div className="dropdown-divider"></div>
                          <a 
                            href="#/" 
                            className="dropdown-item" 
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (window.confirm('Are you sure you want to delete this conversation?')) {
                                onDeleteConversation(conversation.id);
                              }
                            }}
                          >
                            Delete
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="text-center py-4 text-body text-opacity-50">
                <div className="mb-2"><Icon icon="solar:chat-square-outline" className="fs-48px" /></div>
                <div>No conversations yet</div>
                <div className="small">Start a new chat to begin</div>
              </div>
            )}
          </PerfectScrollbar>
        </div>
        
        <hr className="m-0 opacity-20" />
        
        <div className="fs-6 p-2">
          <div className="position-relative hover-bg-light bg-opacity-25 hover-show rounded-2 py-6px px-3 border-0 d-flex align-items-center">
            <i className="far fa-folder fa-lg fa-fw me-2 ms-n2"></i>
            Explore Bots
          </div>
          <div className="position-relative hover-bg-light bg-opacity-25 hover-show rounded-2 py-6px px-3 border-0 d-flex align-items-center">
            <i className="far fa-gem fa-lg fa-fw me-2 ms-n2"></i>
            Go Pro
          </div>
        </div>
        
        <hr className="m-0 opacity-20" />       
       
        <div className="rounded-4 px-3 py-3 border-0">
          <div className="fw-500 flex-1 fs-13px text-body d-flex align-items-center">
            <div className="w-30px h-30px fs-20px me-2 rounded-circle text-white bg-inverse bg-opacity-50 d-flex align-items-center justify-content-center">
              S
            </div>
            support@cyber-point.nl
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatSidebar;